import logoWebp from "@/assets/mywrkdesk-logo.webp";
import logoPng from "@/assets/mywrkdesk-logo.png";

interface LogoProps {
  className?: string;
  variant?: "auto" | "light" | "dark"; // light = for light backgrounds (dark logo), dark = for dark backgrounds (light logo)
}

export function Logo({ className = "", variant = "auto" }: LogoProps) {
  const filterStyle =
    variant === "light"
      ? { filter: "invert(1) brightness(0)" }
      : variant === "dark"
      ? { filter: "invert(1) brightness(2)" }
      : {};

  return (
    <picture>
      <source srcSet={logoWebp} type="image/webp" />
      <img
        src={logoPng}
        alt="MyWrkDesk Logo"
        className={`${className} w-auto object-contain`}
        style={filterStyle}
        width={600}
        height={250}
        fetchPriority="high"
        decoding="async"
      />
    </picture>
  );
}
